import { render, staticRenderFns } from "./addNote.vue?vue&type=template&id=1f39762a&"
import script from "./addNote.vue?vue&type=script&lang=js&"
export * from "./addNote.vue?vue&type=script&lang=js&"
import style0 from "./addNote.vue?vue&type=style&index=0&id=1f39762a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports